import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../security/AuthContext';
import { useEffect, useMemo, useState } from 'react';
import { AvatarButton } from '../components/AvatarButton';

export const TaskBar = ({showSidebar, setShowSidebar}) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [avatar, setAvatar] = useState(user.avatarFile);
  const location = useLocation();

  const handleClick = () => {
    if (location.pathname === '/Profile') {
      navigate(-1);
    } else {
      navigate('/Profile');
    }
  };

  // Load saved avatar if stored in localStorage or server
  useEffect(() => {
    setAvatar(user.avatarFile);
  }, [user]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const avatarUrl = () => {
    return `/api/users/avatar/${user.id}?token=` + localStorage.getItem('token');
  };

  return (
    <header className="bg-gradient-to-r from-purple-600 to-blue-800 text-white h-14 flex items-center justify-between px-4 fixed w-full top-0 z-20 shadow-md">
      <button className="text-3xl font-bold">SendFalcon</button>
      <nav className="flex items-center space-x-4">
        {/* <span className='hidden md:flex space-x-4'> */}
          <AvatarButton user={user} handleClick={handleClick} />
          <a
            onClick={handleLogout}
            className="hover:text-indigo-300 transition-colors cursor-pointer"
          >
            <i className="fas fa-sign-out-alt pr-2"></i>
            Logout
          </a>
        {/* </span> */}
        <button 
          className="md:hidden text-white focus:outline-none cursor-pointer hover:text-blue-100"
          onClick={(e) => {e.stopPropagation(); setShowSidebar(!showSidebar);}}
        >
          <i className="fas fa-bars fa-lg"></i>
        </button>

      </nav>
    </header>
  );
};